export class EditPackageTargetInstallationsReqData {
    packageId: number = -1;
    targetInstallations: string[] = [];
    targetOrganizations: number[] = [];

    constructor(packageId: number, targetInstallations: string[], targetOrganizationsIds: number[]) {
        this.packageId = packageId;
        this.targetInstallations = [];
        if (targetInstallations && targetInstallations.length > 0)
            targetInstallations.forEach((installation) => {
                this.targetInstallations.push(installation);
            });
        if (targetOrganizationsIds && targetOrganizationsIds.length > 0)
            targetOrganizationsIds.forEach((organizationId) => {
                this.targetOrganizations.push(organizationId);
            });
    }
}
